export default __webpack_public_path__ + "static/media/w2v2.82204d6a.jpeg";